export default __webpack_public_path__ + "bg-desktop.png?e38d7339540d7cedc3f25ec90b803b17";